<template>
    <div class="vh-100 bg-light" style="overflow:auto;">
        <div class="row gx-0">
            <div class="col-lg-6">
                <div class="row h-75 align-items-center justify-content-center">
                    <div class="col-xxl-6 col-8">
                        <div class="text-center col-6 m-auto p-3">
                            <img :src="logo" class="img-fluid" />
                        </div>
                        <form class="auth-activate-form" ref="formActivate" novalidate @submit.prevent="submit">
                            <div class="app--card card m-auto p-0">
                                <div class="card-body">
                                    <div v-if="!response.type" class="app--card-title">
                                        <span>Create your password</span>
                                    </div>
                                    <app--alert v-if="response.type" :close="true" :description="response.description"
                                        :icon="response.icon" :title="response.title" :type="response.type"></app--alert>
                                    <div class="mb-3">
                                        <app--password v-model="password" placeholder="Password"
                                            :validate-minlength="security.minlength" :validate-strength="security.strength"
                                            :validate-uppercase="security.r_uppercase"
                                            :validate-lowercase="security.r_lowercase" :validate-number="security.r_number"
                                            :validate-symbol="security.r_symbol" :visibility-toggle="false">
                                            <template v-slot:prepend>
                                                <span class="input-group-text bg-white"><i
                                                        class="fas fa-fw fa-key"></i></span>
                                            </template>
                                        </app--password>
                                    </div>
                                    <div class="mb-3">
                                        <app--password v-model="confirm" placeholder="Confirm" :validate-confirm="password"
                                            :validate-minlength="0" :validate-strength="false" :visibility-toggle="false">
                                            <template v-slot:prepend>
                                                <span class="input-group-text bg-white"><i
                                                        class="fas fa-fw fa-check"></i></span>
                                            </template>
                                        </app--password>
                                    </div>
                                    <div class="d-grid mb-3">
                                        <app--button type="submit" class="btn btn-primary" label="Activate"
                                            :loading="status.loading"></app--button>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <div class="col-lg-6 d-none d-lg-block">
                <auth--splash />
            </div>
        </div>
    </div>
</template>

<script>
import store from './store'
export default {
    props: ['token'],
    computed: {
        logo() { return store.state.logo },
        status() { return store.state.status },
        response() { return this.status.response },
        security() {
            return {
                'minlength': window._rules ? parseInt(window._rules.password_min_length) : 8,
                'strength': window._rules ? window._rules.password_zxcvbnjs === '1' : true,
                'r_uppercase': window._rules && window._rules.password_rule_uppercase === '1',
                'r_lowercase': window._rules && window._rules.password_rule_lowercase === '1',
                'r_number': window._rules && window._rules.password_rule_number === '1',
                'r_symbol': window._rules && window._rules.password_rule_symbol === '1',
            }
        }
    },
    data() {
        return {
            password: '',
            confirm: '',
        }
    },
    methods: {
        submit(event) {
            this.$validate(event).then(() => {
                store.dispatch('activate', {
                    password: this.password,
                    password_confirmation: this.confirm,
                    token: this.token
                })
            })
        },
    }
}
</script>
